import {library} from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { faLightbulb, faHotdog, faMugHot, faHamburger, faAppleAlt, faIceCream, faSearch, faArrowUp} from '@fortawesome/free-solid-svg-icons';

library.add(
    fab,
    faLightbulb,
    faHotdog, 
    faMugHot, 
    faHamburger, 
    faAppleAlt, 
    faIceCream,
    faSearch,
    faArrowUp,
);
